export interface IReqScheduleParams{
    'startTime'?:string,                 //类型：String  可有字段  备注：开始时间 格式：2020-12-12 12:12:12
    'endTime'?:string,                   //类型：String  可有字段  备注：结束时间 格式：2020-12-12 12:12:12
    'pageNum'?:number,                   //类型：Number  必有字段  备注：页码
    'pageSize'?:number,                  //类型：Number  必有字段  备注：一页多少条
    'serviceTeamId'?:number,             //类型：Number  可有字段  备注：团队id
    'projectId'?:number,                 //类型：Number  可有字段  备注：项目id
    'scheduleStatus'?:string,            //类型：String  可有字段  备注：状态，多选，逗号隔开
    'teacherId'?:number []|string [],   //类型：Number  可有字段  备注：老师id,多选，数组
    'sortField'?:string,                 //类型：String  可有字段  备注：排序字段：gls.start_time 服务时间，gls.created_at创建时间
    'sortValue'?:string,                 //类型：String  可有字段  备注：desc-降序；asc-升序
    'serviceTypes'?: string []       //类型：Array  必有字段  备注：上课方式 注：复选
    'batchDeleteDisable'?: boolean,
    'selectedRowKeys'?:string []|number[]
}  

export interface IAddScheduleParams { 
    'projectId':number,                //类型：Number  必有字段  备注：项目id
    'scheduleTitle':string,            //类型：String  必有字段  备注：课程名称
    'serviceTeamId':number,            //类型：Number  必有字段  备注：团队id
    'teacherId':string,                //类型：String  必有字段  备注：老师id
    'serviceType':string,              //类型：String  必有字段  备注：服务类型
    'createBy':number,                 //类型：Number  必有字段  备注：创建人
    'startTime':string,                //类型：String  必有字段  备注：开始时间 格式：2020-12-12 12:12:12
    'endTime':string                   //类型：String  必有字段  备注：结束时间 格式：2020-12-12 12:12:12
}

export interface IGetScheduleParams { 
    'scheduleId':number,	            //必选	坐席id
    'pageSize':number,  	            //必选	无
    'pageNum':number,	                //必选	无
}

export interface IExcelImportList { 
    'startTime'?:string|undefined,     //类型：String  可有字段  备注：开始时间
    'endTime'?:string|undefined,       //类型：String  可有字段  备注：结束时间
    'fileName'?:string|undefined,      //类型：String  可有字段  备注：文件名
    'importSource'?:number|undefined,  //类型：Number  必有字段  备注：导入来源
    'pageNum':number,                  //类型：Number  可有字段  备注：无
    'pageSize':number,                 //类型：Number  可有字段  备注：无
    'processStatus'?:string|undefined, //类型：Number  可有字段  备注：状态：0 未处理 1 已处理
    'userId'?:string|undefined         //类型：Number  可有字段  备注：操作人
}

export interface IExportProps { 
    endTime: string,
    pageNum: number,
    pageSize: number,
    projectId: number,
    scheduleStatus: string
    serviceTeamId: string|number,
    serviceTypes: string [],
    sortField?: string,
    sortValue?: string,
    startTime: string,
    teacherId: number []|string[],
    teamArr?: number []|string []
}

export interface IExcelImport { 
excelUrl: string,
fileName: string,
importSource: number|string, 
userId: number
}

export enum ScheduleType { 
    idle  = 0,
    expired = 1,
    reserved = 2,
    end = 3,
    occupied = 4
}

export enum ImportFileStatus { 
    uploading  = 0,
    uploaded = 1,
    fail = 2
}